export const generatePlaceholder = (value) => Object.prototype.toString.call(value);
//# sourceMappingURL=generatePlaceholder.js.map